// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Advanced Options Trading Dashboard - Modern Design */

.advanced-dashboard {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

.dashboard-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: white;
  font-size: 1.5rem;
}

.dashboard-header-modern {
  text-align: center;
  color: white;
  margin-bottom: 3rem;
  padding: 2rem 0;
}

.dashboard-header-modern h1 {
  font-size: 3rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
}

/* Goal Section */
.goal-section {
  margin-bottom: 3rem;
}

.goal-card {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 1200px;
  margin: 0 auto;
}

.goal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.goal-header h2 {
  margin: 0;
  font-size: 1.8rem;
  color: #333;
}

.goal-target {
  font-size: 1.5rem;
  font-weight: 700;
  color: #667eea;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.goal-progress-container {
  margin-top: 2rem;
}

.goal-progress-bar {
  width: 100%;
  height: 50px;
  background: #e0e0e0;
  border-radius: 25px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.goal-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4caf50 0%, #45a049 100%);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 1s ease;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.4);
}

.goal-progress-text {
  color: white;
  font-weight: 700;
  font-size: 1.1rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.goal-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;
}

.goal-stat {
  text-align: center;
  padding: 1.5rem;
  background: #f5f5f5;
  border-radius: 12px;
}

.goal-stat-label {
  display: block;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.goal-stat-value {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
}

/* Monthly Equity Section */
.monthly-equity-section {
  margin-bottom: 3rem;
}

.section-card {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 1400px;
  margin: 0 auto;
}

.section-card h2 {
  margin: 0 0 2rem 0;
  font-size: 1.8rem;
  color: #333;
  border-bottom: 3px solid #667eea;
  padding-bottom: 1rem;
}

.monthly-breakdown {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.month-card {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 1.5rem;
  border-left: 4px solid #ccc;
  transition: transform 0.2s, box-shadow 0.2s;
}

.month-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.month-card.positive {
  border-left-color: #4caf50;
  background: #f1f8f4;
}

.month-card.negative {
  border-left-color: #d32f2f;
  background: #fff5f5;
}

.month-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.month-name {
  font-weight: 600;
  color: #333;
  font-size: 1.1rem;
}

.month-status {
  font-size: 1.5rem;
  font-weight: 700;
}

.month-status.positive {
  color: #4caf50;
}

.month-status.negative {
  color: #d32f2f;
}

.month-values {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.month-value {
  display: flex;
  justify-content: space-between;
}

.month-value .label {
  color: #666;
  font-size: 0.9rem;
}

.month-value .value {
  font-weight: 600;
  color: #333;
}

.month-value .value.positive {
  color: #4caf50;
}

.month-value .value.negative {
  color: #d32f2f;
}

/* Chart Containers */
.chart-container-large {
  margin-top: 2rem;
  padding: 1rem;
  background: #fafafa;
  border-radius: 12px;
}

.chart-container {
  margin-top: 1rem;
  padding: 1rem;
  background: #fafafa;
  border-radius: 12px;
}

/* Weekly P&L Section */
.weekly-pnl-section {
  margin-bottom: 3rem;
}

/* Covered Calls Section */
.covered-calls-section {
  margin-bottom: 3rem;
}

.income-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid #e0e0e0;
}

.income-stat {
  text-align: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
  border-radius: 12px;
  color: white;
}

.income-stat .label {
  display: block;
  font-size: 0.9rem;
  opacity: 0.9;
  margin-bottom: 0.5rem;
}

.income-stat .value {
  display: block;
  font-size: 1.8rem;
  font-weight: 700;
}

/* Metrics Grid */
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.metric-card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1.5rem;
  transition: transform 0.2s, box-shadow 0.2s;
}

.metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.metric-icon {
  font-size: 3rem;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  flex-shrink: 0;
}

.metric-content {
  flex: 1 1;
}

.metric-content h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: #666;
  font-weight: 500;
}

.metric-value {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.25rem;
}

.metric-desc {
  margin: 0;
  font-size: 0.85rem;
  color: #999;
}

/* Position Distribution */
.position-distribution-section {
  margin-bottom: 3rem;
}

/* P&L Distribution */
.pnl-distribution-section {
  margin-bottom: 3rem;
}

/* Performance Section */
.performance-section {
  margin-bottom: 3rem;
}

.performance-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.performance-list {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 1.5rem;
}

.performance-list h3 {
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
  color: #333;
}

.performance-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  margin-bottom: 0.5rem;
}

.performance-item .rank {
  font-weight: 700;
  color: #667eea;
  min-width: 30px;
}

.performance-item .symbol {
  flex: 1 1;
  font-weight: 500;
}

.performance-item .pnl {
  font-weight: 700;
}

.performance-item .pnl.positive {
  color: #4caf50;
}

.performance-item .pnl.negative {
  color: #d32f2f;
}

/* Strategy Section */
.strategy-section {
  margin-bottom: 3rem;
}

.strategy-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.strategy-stat {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  color: white;
}

.strategy-stat h3 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  opacity: 0.9;
}

.strategy-stat .stat-value {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.strategy-stat .stat-desc {
  margin: 0;
  opacity: 0.8;
  font-size: 0.9rem;
}

/* Risk Metrics */
.risk-metrics-section {
  margin-bottom: 3rem;
}

.risk-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.risk-card {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  border-left: 4px solid #667eea;
}

.risk-card h3 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  color: #666;
}

.risk-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.risk-card p {
  margin: 0;
  font-size: 0.85rem;
  color: #999;
}

/* Frequency Section */
.frequency-section {
  margin-bottom: 3rem;
}

.frequency-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.frequency-item {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
}

.frequency-item .label {
  display: block;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.frequency-item .value {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
}

.frequency-item .value.positive {
  color: #4caf50;
}

.frequency-item .value.negative {
  color: #d32f2f;
}

/* Greeks Heatmap */
.greeks-heatmap-section {
  margin-bottom: 3rem;
}

.greeks-heatmap {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.greek-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.greek-label {
  min-width: 120px;
  font-weight: 600;
  color: #333;
}

.greek-bar {
  flex: 1 1;
  height: 40px;
  background: #e0e0e0;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
}

.greek-fill {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  border-radius: 20px;
  transition: width 0.5s ease;
}

.greek-fill.delta {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.greek-fill.gamma {
  background: linear-gradient(90deg, #f093fb 0%, #f5576c 100%);
}

.greek-fill.theta {
  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%);
}

.greek-fill.vega {
  background: linear-gradient(90deg, #43e97b 0%, #38f9d7 100%);
}

/* Income Summary */
.income-summary-section {
  margin-bottom: 3rem;
}

.income-chart-container {
  margin-top: 2rem;
  padding: 1rem;
  background: #fafafa;
  border-radius: 12px;
}

/* Account Allocation */
.account-allocation-section {
  margin-bottom: 3rem;
}

.allocation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.5rem;
}

.allocation-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  color: white;
}

.allocation-card h3 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  opacity: 0.9;
}

.allocation-value {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.allocation-percent {
  font-size: 1.2rem;
  opacity: 0.8;
}

/* Rolling Returns */
.rolling-returns-section {
  margin-bottom: 3rem;
}

.returns-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.return-item {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
}

.return-item .label {
  display: block;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.return-item .value {
  display: block;
  font-size: 1.8rem;
  font-weight: 700;
  color: #4caf50;
}

/* Time Decay */
.time-decay-section {
  margin-bottom: 3rem;
}

.theta-analysis {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.theta-card {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  color: white;
}

.theta-card h3 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  opacity: 0.9;
}

.theta-value {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.theta-card p {
  margin: 0;
  opacity: 0.8;
  font-size: 0.9rem;
}

/* Volatility */
.volatility-section {
  margin-bottom: 3rem;
}

.volatility-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.volatility-item {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
}

.volatility-item .label {
  display: block;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.volatility-item .value {
  display: block;
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.volatility-item p {
  margin: 0;
  font-size: 0.85rem;
  color: #999;
}

/* Market Exposure */
.market-exposure-section {
  margin-bottom: 3rem;
}

.exposure-chart {
  margin-top: 2rem;
  padding: 1rem;
  background: #fafafa;
  border-radius: 12px;
}

/* Performance Attribution */
.attribution-section {
  margin-bottom: 3rem;
}

.attribution-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.attribution-item {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
}

.attribution-item .label {
  display: block;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.attribution-item .value {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
}

.attribution-item .value.positive {
  color: #4caf50;
}

/* Trade Journal */
.journal-section {
  margin-bottom: 3rem;
}

.insights-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.insight-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  border-left: 4px solid #667eea;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.insight-card h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: #333;
}

.insight-card p {
  margin: 0 0 1rem 0;
  font-size: 0.9rem;
  color: #666;
}

.insight-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
}

.insight-value.positive {
  color: #4caf50;
}

/* Correlation */
.correlation-section {
  margin-bottom: 3rem;
}

.correlation-matrix {
  padding: 2rem;
  background: #f9f9f9;
  border-radius: 12px;
  text-align: center;
}

.correlation-matrix p {
  margin: 0.5rem 0;
  font-size: 1.1rem;
  color: #333;
}

/* Alerts */
.alerts-section {
  margin-bottom: 3rem;
}

.alerts-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.alert-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 12px;
}

.alert-item.active {
  background: #f1f8f4;
  border-left: 4px solid #4caf50;
}

.alert-icon {
  font-size: 1.5rem;
  font-weight: 700;
  color: #4caf50;
}

.alert-item:not(.active) .alert-icon {
  color: #999;
}

.alert-text {
  font-weight: 500;
  color: #333;
}

/* Footer */
.dashboard-footer {
  text-align: center;
  color: white;
  padding: 2rem 0;
  opacity: 0.8;
}

.footer-note {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  opacity: 0.7;
}

/* Info Button Styles */
.info-button {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2rem;
  transition: all 0.2s;
  color: white;
  flex-shrink: 0;
}

.info-button:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: scale(1.1);
}

.section-header-with-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  border-bottom: 3px solid #667eea;
  padding-bottom: 1rem;
}

.section-header-with-info h2 {
  margin: 0;
  font-size: 1.8rem;
  color: #333;
}

.metric-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.metric-header h3 {
  margin: 0;
  font-size: 1rem;
  color: #666;
}

.info-button-small {
  background: transparent;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  color: #667eea;
  flex-shrink: 0;
  padding: 0;
}

.info-button-small:hover {
  background: #f0f0f0;
  border-color: #667eea;
  transform: scale(1.1);
}

/* Info Modal */
.info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 2rem;
  animation: fadeIn 0.2s ease;
}

.info-modal {
  background: white;
  border-radius: 20px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

.info-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 1rem 2rem;
  border-bottom: 2px solid #e0e0e0;
}

.info-modal-header h2 {
  margin: 0;
  font-size: 1.8rem;
  color: #333;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.info-modal-close {
  background: #f5f5f5;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.5rem;
  color: #666;
  transition: all 0.2s;
  padding: 0;
}

.info-modal-close:hover {
  background: #e0e0e0;
  color: #333;
  transform: rotate(90deg);
}

.info-modal-content {
  padding: 2rem;
}

.info-modal-content p {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive modal */
@media (max-width: 768px) {
  .info-modal {
    max-width: 90%;
    margin: 1rem;
  }
  
  .info-modal-header,
  .info-modal-content {
    padding: 1.5rem;
  }
  
  .info-modal-header h2 {
    font-size: 1.5rem;
  }
}

/* Responsive Design */
@media (max-width: 1200px) {
  .goal-stats {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .monthly-breakdown {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (max-width: 768px) {
  .advanced-dashboard {
    padding: 1rem;
  }
  
  .dashboard-header-modern h1 {
    font-size: 2rem;
  }
  
  .goal-stats {
    grid-template-columns: 1fr;
  }
  
  .monthly-breakdown {
    grid-template-columns: 1fr;
  }
  
  .income-summary {
    grid-template-columns: 1fr;
  }
  
  .metrics-grid {
    grid-template-columns: 1fr;
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-card {
  animation: fadeIn 0.5s ease;
}

.metric-card {
  animation: fadeIn 0.5s ease;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #667eea;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #764ba2;
}

`, "",{"version":3,"sources":["webpack://./src/AdvancedOptionsDashboard.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,iHAAiH;AACnH;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Advanced Options Trading Dashboard - Modern Design */\n\n.advanced-dashboard {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 2rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n}\n\n.dashboard-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  color: white;\n  font-size: 1.5rem;\n}\n\n.dashboard-header-modern {\n  text-align: center;\n  color: white;\n  margin-bottom: 3rem;\n  padding: 2rem 0;\n}\n\n.dashboard-header-modern h1 {\n  font-size: 3rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.subtitle {\n  font-size: 1.2rem;\n  opacity: 0.9;\n  margin: 0;\n}\n\n/* Goal Section */\n.goal-section {\n  margin-bottom: 3rem;\n}\n\n.goal-card {\n  background: white;\n  border-radius: 20px;\n  padding: 2.5rem;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.goal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.goal-header h2 {\n  margin: 0;\n  font-size: 1.8rem;\n  color: #333;\n}\n\n.goal-target {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #667eea;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.goal-progress-container {\n  margin-top: 2rem;\n}\n\n.goal-progress-bar {\n  width: 100%;\n  height: 50px;\n  background: #e0e0e0;\n  border-radius: 25px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.goal-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #4caf50 0%, #45a049 100%);\n  border-radius: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: width 1s ease;\n  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.4);\n}\n\n.goal-progress-text {\n  color: white;\n  font-weight: 700;\n  font-size: 1.1rem;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.goal-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.goal-stat {\n  text-align: center;\n  padding: 1.5rem;\n  background: #f5f5f5;\n  border-radius: 12px;\n}\n\n.goal-stat-label {\n  display: block;\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n}\n\n.goal-stat-value {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #333;\n}\n\n/* Monthly Equity Section */\n.monthly-equity-section {\n  margin-bottom: 3rem;\n}\n\n.section-card {\n  background: white;\n  border-radius: 20px;\n  padding: 2.5rem;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.section-card h2 {\n  margin: 0 0 2rem 0;\n  font-size: 1.8rem;\n  color: #333;\n  border-bottom: 3px solid #667eea;\n  padding-bottom: 1rem;\n}\n\n.monthly-breakdown {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.month-card {\n  background: #f9f9f9;\n  border-radius: 12px;\n  padding: 1.5rem;\n  border-left: 4px solid #ccc;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.month-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.month-card.positive {\n  border-left-color: #4caf50;\n  background: #f1f8f4;\n}\n\n.month-card.negative {\n  border-left-color: #d32f2f;\n  background: #fff5f5;\n}\n\n.month-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.month-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.month-status {\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.month-status.positive {\n  color: #4caf50;\n}\n\n.month-status.negative {\n  color: #d32f2f;\n}\n\n.month-values {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.month-value {\n  display: flex;\n  justify-content: space-between;\n}\n\n.month-value .label {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.month-value .value {\n  font-weight: 600;\n  color: #333;\n}\n\n.month-value .value.positive {\n  color: #4caf50;\n}\n\n.month-value .value.negative {\n  color: #d32f2f;\n}\n\n/* Chart Containers */\n.chart-container-large {\n  margin-top: 2rem;\n  padding: 1rem;\n  background: #fafafa;\n  border-radius: 12px;\n}\n\n.chart-container {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #fafafa;\n  border-radius: 12px;\n}\n\n/* Weekly P&L Section */\n.weekly-pnl-section {\n  margin-bottom: 3rem;\n}\n\n/* Covered Calls Section */\n.covered-calls-section {\n  margin-bottom: 3rem;\n}\n\n.income-summary {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 2px solid #e0e0e0;\n}\n\n.income-stat {\n  text-align: center;\n  padding: 1.5rem;\n  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);\n  border-radius: 12px;\n  color: white;\n}\n\n.income-stat .label {\n  display: block;\n  font-size: 0.9rem;\n  opacity: 0.9;\n  margin-bottom: 0.5rem;\n}\n\n.income-stat .value {\n  display: block;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n/* Metrics Grid */\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.metric-card {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.metric-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.metric-icon {\n  font-size: 3rem;\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 16px;\n  flex-shrink: 0;\n}\n\n.metric-content {\n  flex: 1;\n}\n\n.metric-content h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  color: #666;\n  font-weight: 500;\n}\n\n.metric-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 0.25rem;\n}\n\n.metric-desc {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #999;\n}\n\n/* Position Distribution */\n.position-distribution-section {\n  margin-bottom: 3rem;\n}\n\n/* P&L Distribution */\n.pnl-distribution-section {\n  margin-bottom: 3rem;\n}\n\n/* Performance Section */\n.performance-section {\n  margin-bottom: 3rem;\n}\n\n.performance-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n}\n\n.performance-list {\n  background: #f9f9f9;\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.performance-list h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.performance-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem;\n  background: white;\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n}\n\n.performance-item .rank {\n  font-weight: 700;\n  color: #667eea;\n  min-width: 30px;\n}\n\n.performance-item .symbol {\n  flex: 1;\n  font-weight: 500;\n}\n\n.performance-item .pnl {\n  font-weight: 700;\n}\n\n.performance-item .pnl.positive {\n  color: #4caf50;\n}\n\n.performance-item .pnl.negative {\n  color: #d32f2f;\n}\n\n/* Strategy Section */\n.strategy-section {\n  margin-bottom: 3rem;\n}\n\n.strategy-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n}\n\n.strategy-stat {\n  text-align: center;\n  padding: 2rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 16px;\n  color: white;\n}\n\n.strategy-stat h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  opacity: 0.9;\n}\n\n.strategy-stat .stat-value {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.strategy-stat .stat-desc {\n  margin: 0;\n  opacity: 0.8;\n  font-size: 0.9rem;\n}\n\n/* Risk Metrics */\n.risk-metrics-section {\n  margin-bottom: 3rem;\n}\n\n.risk-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n}\n\n.risk-card {\n  background: #f5f5f5;\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n  border-left: 4px solid #667eea;\n}\n\n.risk-card h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  color: #666;\n}\n\n.risk-value {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.risk-card p {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #999;\n}\n\n/* Frequency Section */\n.frequency-section {\n  margin-bottom: 3rem;\n}\n\n.frequency-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n}\n\n.frequency-item {\n  background: #f9f9f9;\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.frequency-item .label {\n  display: block;\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n}\n\n.frequency-item .value {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #333;\n}\n\n.frequency-item .value.positive {\n  color: #4caf50;\n}\n\n.frequency-item .value.negative {\n  color: #d32f2f;\n}\n\n/* Greeks Heatmap */\n.greeks-heatmap-section {\n  margin-bottom: 3rem;\n}\n\n.greeks-heatmap {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.greek-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.greek-label {\n  min-width: 120px;\n  font-weight: 600;\n  color: #333;\n}\n\n.greek-bar {\n  flex: 1;\n  height: 40px;\n  background: #e0e0e0;\n  border-radius: 20px;\n  overflow: hidden;\n  position: relative;\n}\n\n.greek-fill {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  border-radius: 20px;\n  transition: width 0.5s ease;\n}\n\n.greek-fill.delta {\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n}\n\n.greek-fill.gamma {\n  background: linear-gradient(90deg, #f093fb 0%, #f5576c 100%);\n}\n\n.greek-fill.theta {\n  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%);\n}\n\n.greek-fill.vega {\n  background: linear-gradient(90deg, #43e97b 0%, #38f9d7 100%);\n}\n\n/* Income Summary */\n.income-summary-section {\n  margin-bottom: 3rem;\n}\n\n.income-chart-container {\n  margin-top: 2rem;\n  padding: 1rem;\n  background: #fafafa;\n  border-radius: 12px;\n}\n\n/* Account Allocation */\n.account-allocation-section {\n  margin-bottom: 3rem;\n}\n\n.allocation-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1.5rem;\n}\n\n.allocation-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n  color: white;\n}\n\n.allocation-card h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  opacity: 0.9;\n}\n\n.allocation-value {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.allocation-percent {\n  font-size: 1.2rem;\n  opacity: 0.8;\n}\n\n/* Rolling Returns */\n.rolling-returns-section {\n  margin-bottom: 3rem;\n}\n\n.returns-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n}\n\n.return-item {\n  background: #f9f9f9;\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.return-item .label {\n  display: block;\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n}\n\n.return-item .value {\n  display: block;\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #4caf50;\n}\n\n/* Time Decay */\n.time-decay-section {\n  margin-bottom: 3rem;\n}\n\n.theta-analysis {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n}\n\n.theta-card {\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n  border-radius: 16px;\n  padding: 2rem;\n  text-align: center;\n  color: white;\n}\n\n.theta-card h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  opacity: 0.9;\n}\n\n.theta-value {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.theta-card p {\n  margin: 0;\n  opacity: 0.8;\n  font-size: 0.9rem;\n}\n\n/* Volatility */\n.volatility-section {\n  margin-bottom: 3rem;\n}\n\n.volatility-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n}\n\n.volatility-item {\n  background: #f9f9f9;\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.volatility-item .label {\n  display: block;\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n}\n\n.volatility-item .value {\n  display: block;\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.volatility-item p {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #999;\n}\n\n/* Market Exposure */\n.market-exposure-section {\n  margin-bottom: 3rem;\n}\n\n.exposure-chart {\n  margin-top: 2rem;\n  padding: 1rem;\n  background: #fafafa;\n  border-radius: 12px;\n}\n\n/* Performance Attribution */\n.attribution-section {\n  margin-bottom: 3rem;\n}\n\n.attribution-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n}\n\n.attribution-item {\n  background: #f9f9f9;\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.attribution-item .label {\n  display: block;\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n}\n\n.attribution-item .value {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #333;\n}\n\n.attribution-item .value.positive {\n  color: #4caf50;\n}\n\n/* Trade Journal */\n.journal-section {\n  margin-bottom: 3rem;\n}\n\n.insights-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n}\n\n.insight-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  border-left: 4px solid #667eea;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.insight-card h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  color: #333;\n}\n\n.insight-card p {\n  margin: 0 0 1rem 0;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.insight-value {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #333;\n}\n\n.insight-value.positive {\n  color: #4caf50;\n}\n\n/* Correlation */\n.correlation-section {\n  margin-bottom: 3rem;\n}\n\n.correlation-matrix {\n  padding: 2rem;\n  background: #f9f9f9;\n  border-radius: 12px;\n  text-align: center;\n}\n\n.correlation-matrix p {\n  margin: 0.5rem 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n/* Alerts */\n.alerts-section {\n  margin-bottom: 3rem;\n}\n\n.alerts-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n}\n\n.alert-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: #f9f9f9;\n  border-radius: 12px;\n}\n\n.alert-item.active {\n  background: #f1f8f4;\n  border-left: 4px solid #4caf50;\n}\n\n.alert-icon {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #4caf50;\n}\n\n.alert-item:not(.active) .alert-icon {\n  color: #999;\n}\n\n.alert-text {\n  font-weight: 500;\n  color: #333;\n}\n\n/* Footer */\n.dashboard-footer {\n  text-align: center;\n  color: white;\n  padding: 2rem 0;\n  opacity: 0.8;\n}\n\n.footer-note {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n  opacity: 0.7;\n}\n\n/* Info Button Styles */\n.info-button {\n  background: rgba(255, 255, 255, 0.2);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 1.2rem;\n  transition: all 0.2s;\n  color: white;\n  flex-shrink: 0;\n}\n\n.info-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: scale(1.1);\n}\n\n.section-header-with-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  border-bottom: 3px solid #667eea;\n  padding-bottom: 1rem;\n}\n\n.section-header-with-info h2 {\n  margin: 0;\n  font-size: 1.8rem;\n  color: #333;\n}\n\n.metric-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.metric-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  color: #666;\n}\n\n.info-button-small {\n  background: transparent;\n  border: 1px solid #ddd;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n  color: #667eea;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.info-button-small:hover {\n  background: #f0f0f0;\n  border-color: #667eea;\n  transform: scale(1.1);\n}\n\n/* Info Modal */\n.info-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 2rem;\n  animation: fadeIn 0.2s ease;\n}\n\n.info-modal {\n  background: white;\n  border-radius: 20px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease;\n}\n\n.info-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem 2rem 1rem 2rem;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.info-modal-header h2 {\n  margin: 0;\n  font-size: 1.8rem;\n  color: #333;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.info-modal-close {\n  background: #f5f5f5;\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 1.5rem;\n  color: #666;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.info-modal-close:hover {\n  background: #e0e0e0;\n  color: #333;\n  transform: rotate(90deg);\n}\n\n.info-modal-content {\n  padding: 2rem;\n}\n\n.info-modal-content p {\n  margin: 0;\n  font-size: 1.1rem;\n  line-height: 1.6;\n  color: #555;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Responsive modal */\n@media (max-width: 768px) {\n  .info-modal {\n    max-width: 90%;\n    margin: 1rem;\n  }\n  \n  .info-modal-header,\n  .info-modal-content {\n    padding: 1.5rem;\n  }\n  \n  .info-modal-header h2 {\n    font-size: 1.5rem;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .goal-stats {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .monthly-breakdown {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .advanced-dashboard {\n    padding: 1rem;\n  }\n  \n  .dashboard-header-modern h1 {\n    font-size: 2rem;\n  }\n  \n  .goal-stats {\n    grid-template-columns: 1fr;\n  }\n  \n  .monthly-breakdown {\n    grid-template-columns: 1fr;\n  }\n  \n  .income-summary {\n    grid-template-columns: 1fr;\n  }\n  \n  .metrics-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.section-card {\n  animation: fadeIn 0.5s ease;\n}\n\n.metric-card {\n  animation: fadeIn 0.5s ease;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #667eea;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #764ba2;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
